import { TFunction } from 'i18next';

export type StopOrderTranslations = {
  stopOrder: string;
  stopOrderInfoTitle: string;
  stopOrderInfoSubtitle: string;
  stopOrderInfoCurrentPriceLegend: string;
  stopOrderInfoStopPriceLegend: string;
  stopOrderInfo1: string;
  stopOrderInfo2: string;
  gotIt: string;
  stopOrderTitle: string;
  stopOrderActiveTitle: string;
  stopOrdersActiveTitle: string;
  stopOrdersEmpty: string;
  stopOrderNew: string;
  stopOrderManage: string;
  stopOrderNewButton: string;
  seeAll: string;
  orderRejectionTitle: string;
  orderRejectionDescription2: string;
  orderRejectionDescription1: string;
  okGotIt: string;
  viewDetails: string;
  tryAgain: string;
  goToPortfolio: string;
};

const stopOrderTranslations: StopOrderTranslations = {
  stopOrder: 'stop_order_@tenant',
  stopOrderInfoTitle: 'stop_order_info_title',
  stopOrderInfoSubtitle: 'stop_order_info_subtitle_@tenant',
  stopOrderInfoCurrentPriceLegend: 'stop_order_info_current_price_legend',
  stopOrderInfoStopPriceLegend: 'stop_order_info_stop_price_legend_@tenant',
  stopOrderInfo1: 'stop_order_info_1_@tenant',
  stopOrderInfo2: 'stop_order_info_2_@tenant',
  gotIt: 'got_it',
  stopOrderTitle: 'stop_orders_title_@tenant',
  stopOrderActiveTitle: 'stop_order_active_title',
  stopOrdersActiveTitle: 'stop_orders_active_title',
  stopOrdersEmpty: 'stop_orders_empty',
  stopOrderNew: 'stop_order_new',
  stopOrderNewButton: 'stop_order_new_stop_@tenant',
  stopOrderManage: 'stop_order_manage',
  seeAll: 'see_all',
  orderRejectionTitle: 'stop_order_buy_rejection_title',
  orderRejectionDescription2: 'stop_order_buy_error_subtitle_@tenant',
  orderRejectionDescription1: 'internal.error_title',
  okGotIt: 'ok_got_it_button',
  viewDetails: 'view_details',
  tryAgain: 'try_again',
  goToPortfolio: 'ok_go_to_portfolio',
};

export const getStopOrderTranslations = (
  translationUtil: TFunction,
): StopOrderTranslations => {
  return Object.entries(stopOrderTranslations).reduce((acc, [key, value]) => {
    acc[key as keyof StopOrderTranslations] = translationUtil(value);

    return acc;
  }, {} as StopOrderTranslations);
};
